import React, { useEffect, useState } from "react";
import { Form, Col, Row, Select, Button, Space, Card } from "antd";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import TableComponent from "../common/table/TableComponent";
import { useNavigate } from "react-router-dom";

function Result() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [getStudentResponse, getStudentsRequest] = useApi(
    "/admin/student/get-all",
    null,
    API_METHODS.GET
  );

  const [getTestsResponse, getTestsRequest] = useApi(
    "/admin/student/get-tests",
    null,
    API_METHODS.GET
  );

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Month",
      dataIndex: "month",
    },
    {
      title: "Week",
      dataIndex: "week",
    },
    {
      title: "Mock Test Number",
      dataIndex: "mock_test_number",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => viewResult(record)}>
            View Result
          </Button>
        </Space>
      ),
    },
  ];

  const [students, setStudents] = useState([]);
  const [tests, setTests] = useState([]);

  useEffect(() => {
    getStudentsRequest();
  }, []);

  useEffect(() => {
    const data =
      getStudentResponse.data !== BLANK_VALUE ? getStudentResponse.data : [];
    setStudents(data);
  }, [getStudentResponse]);

  useEffect(() => {
    const data =
      getTestsResponse.data !== BLANK_VALUE ? getTestsResponse.data : [];
    setTests(data);
  }, [getTestsResponse]);

  const fetchTests = (values) => {
    getTestsRequest(
      null,
      API_METHODS.GET,
      `/admin/student/get-tests?student_id=${values.student_id}`
    );
  };

  const viewResult = (record) => {
    navigate("/portal/result/detail", {
      state: record,
    });
  };

  return (
    <Card title="Result">
      {students?.length > 0 && (
        <Form form={form} onFinish={fetchTests}>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="student_id"
                label="Student"
                rules={[{ required: true, message: "Student is required." }]}
              >
                <Select
                  placeholder="Select Student"
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {students.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={3}>
              <Button type="primary" htmlType="submit">
                Search
              </Button>
            </Col>
          </Row>

        </Form>
      )}
      {tests && (
        <TableComponent
          columns={columns}
          tableData={tests}
        // onPaginationChange={onPaginationChange}
        // total={totalRecords}
        // current={currentPage}
        />
      )}
    </Card>
  );
}

export default Result;
